import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { motion } from "framer-motion";

import "./Skill.css";
import TopBar from "../../components/TopBar/TopBar";
import { client } from "../../client";
import Marquee from "react-fast-marquee";

import tick from "../../Images/tick.gif";

const Skill = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Skills - Shreeyash Parsawar | Portfolio";
  }, []);

  // part 1

  const [skillsection, setSkillsection] = useState([]);

  useEffect(() => {
    const query = `*[_type == "iamgoodat"]{
            id,
            goodatname,
            goodatimg{
              asset->{
                  _id,
                  url
              }
          }
              
          }| order(id asc) `;

    client.fetch(query).then((data) => {
      setSkillsection(data);
    });
  }, []);

  // part 1

  // part 2

  const [myskillsection, setMyskillsection] = useState([]);

  useEffect(() => {
    const query = `*[_type == "skill"]{
            skillname,
            skillimg{
              asset->{
                  _id,
                  url
              }
          }
              
          }| order(id asc) `;

    client.fetch(query).then((data) => {
      setMyskillsection(data);
    });
  }, []);

  // part 2

  // Part 3

  const [knowledgess, setKnowledgess] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "knowledgeiknow"]{
            id,
            knowledgename            
          }| order(id asc) `;

    client.fetch(query).then((data) => {
      setKnowledgess(data);
      setLoading(false);
    });
  }, []);

  // Part 3

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionSkill pb-5">
          <TopBar />
          {/* PArt 1 */}

          <div className="container pb-5">
            <div className="row">
              {/* heading text one  */}

              <div className="col-lg-12">
                <div className="wrapper">
                  <svg>
                    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                      I Am Good At.....
                    </text>
                  </svg>
                </div>
              </div>

              {/* heading text one  */}

              {/* i m good at section  */}

              {skillsection &&
                skillsection.map((goodat, index) => (
                  <div
                    className="col-lg-4 mt-3 col-md-6  text-center"
                    key={index}
                  >
                    <div className="card cards-img-left zoomicon">
                      <img
                        src={goodat.goodatimg.asset.url}
                        className="card-img-top img-fluid"
                        style={{ width: "100px", height: "100px" }}
                      />

                      <div className="card-body">
                        <h5 className="card-title skill_font">
                          {goodat.goodatname}
                        </h5>
                      </div>
                    </div>
                  </div>
                ))}

              {/* i m good at section  */}
            </div>
          </div>

          {/* PArt 1 */}

          {/* ------------------------------------------------------------------- */}

          {/* Part 2 */}

          <div className="container-fluid pb-5">
            <div className="row">
              <div className="col-lg-12">
                <div className="wrapper">
                  <svg>
                    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                      My Skills
                    </text>
                  </svg>
                </div>
              </div>

              {/* skills marquee section  */}

              <div className="skillsContainer">
                <div className="skill--scroll">
                  <Marquee
                    gradient={false}
                    speed={80}
                    pauseOnHover={true}
                    pauseOnClick={true}
                    delay={0}
                    play={true}
                    direction="left"
                  >
                    {myskillsection &&
                      myskillsection.map((myskilldata, index) => (
                        <div className="skill--box" key={index}>
                          <img src={myskilldata.skillimg.asset.url} alt="" />
                          <h3 className="skill_font">
                            {myskilldata.skillname}
                          </h3>
                        </div>
                      ))}
                  </Marquee>
                </div>
              </div>

              {/* skills marquee section  */}
            </div>
          </div>

          {/* Part 2 */}

          {/* ------------------------------------------------------------------- */}

          {/* Part 3*/}

          <div className="container-fluid pb-5 ">
            <div className="row">
              {/* heading text one  */}

              <div className="col-lg-12">
                <div className="wrapper">
                  <svg>
                    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                      Knowledge
                    </text>
                  </svg>
                </div>
              </div>

              {/* heading text one  */}

              {/* Knowledge section  */}

              <div className="container knowledge_div">
                <div className="row">
                  {knowledgess &&
                    knowledgess.map((kdata, index) => (
                      <div className="col-lg-4 col-md-6 skill_font" key={index}>
                        <img
                          src={tick}
                          alt=""
                          className="img-fluid"
                          style={{ width: "50px", height: "50px" }}
                        />
                        {kdata.knowledgename}
                      </div>
                    ))}
                </div>
              </div>

              {/* Knowledge section  */}
            </div>
          </div>

          {/* Part 3 */}

          {/* ------------------------------------------------------------------- */}
        </section>
      )}
    </motion.div>
  );
};

export default Skill;
